//Create Member by Super or Admin
import * as React from 'react';
import { useEffect, useState } from "react";
import {
  Box, Container, Grid, Typography, TextField, Button, MenuItem, Snackbar, Select, InputLabel, Alert, Autocomplete, CircularProgress, Paper,
} from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useMutation } from "@apollo/client";
import { ADMIN_ADD_MEMBER_MUTATION } from "../graphql/mutations";

export default function FormComponent() {
  const [addMember, { loading: isLoading }] = useMutation(ADMIN_ADD_MEMBER_MUTATION);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    dob: "",
    state: "",
    district: "",
    city: "",
    pincode: "",
    identityProofType: "",
    identityProofNumber: "",
    panCard: "",
    panCardNumber: "",
    email: "",
    occupation: "",
    address: "",
    familyDetails: "",
    maritalStatus: "",
    star: "",
    raasi: "",
    kootram: "",
    kuladeivam: "",
  });

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstName) {
      console.log("first name issue");
      newErrors.firstName = "First Name is required ";
    }
    if (!formData.lastName) {
      console.log("last name issue");
      newErrors.Last_Name = "Last Name is required";
    }
    if (!formData.dob.trim()) {
      newErrors.dob = "Date of Birth is required";
    } else {
      const selectedDate = new Date(formData.dob);
      const today = new Date();
      const minDate = new Date("1900-01-01");

      const minAllowedDate = new Date();
      minAllowedDate.setFullYear(today.getFullYear() - 18);

      // Remove time part for accurate date comparison
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);
      minDate.setHours(0, 0, 0, 0);
      minAllowedDate.setHours(0, 0, 0, 0);

      if (selectedDate >= today) {
        newErrors.dob = "Date of Birth must be in the past";
      } else if (selectedDate < minDate) {
        newErrors.dob = "Date of Birth must be after 01-01-1900";
      } else if (selectedDate > minAllowedDate) {
        newErrors.dob = "Minimum age required to register is 18 years.";
      }
    }
    if (!formData.mobile) {
      console.log("mobile issue");
      newErrors.Mobile_Number = "Mobile Number is required";
    } else if (formData.mobile.length !== 10) {
      newErrors.Mobile_Number = "Mobile number must be exactly 10 digits";
    }
    if (!formData.city) {
      console.log("city issue");
      newErrors.City = "City is required";
    }
    if (!formData.district) {
      console.log("district issue");
      newErrors.district = "District is required";
    }
    if (!formData.state) {
      console.log("state issue");
      newErrors.state = "State is required";
    }
    if (!formData.pincode) {
      console.log("pincode issue");
      newErrors.pincode = "Pincode is required";
    } else if (formData.pincode.length !== 6) {
      newErrors.pincode = "Pincode must be exactly 6 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateDob = (dob) => {
    if (!dob?.trim()) return "Date of Birth is required";
    const selectedDate = new Date(dob);
    const today = new Date();
    const minDate = new Date("1900-01-01");
    const minAllowedDate = new Date();
    minAllowedDate.setFullYear(today.getFullYear() - 18);
    today.setHours(0, 0, 0, 0);
    selectedDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);
    minAllowedDate.setHours(0, 0, 0, 0);
    if (selectedDate >= today) return "Date of Birth must be in the past";
    if (selectedDate < minDate) return "Date of Birth must be after 01-01-1900";
    if (selectedDate > minAllowedDate) return "Minimum age required to register is 18 years.";
    return "";
  };
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = async (e) => {
    window.scrollTo(0, 0);
    e.preventDefault();
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }
    if (!validateDob()) {
      return; // Stop submission if validation fails
    }

    setIsSubmitted(true);
    const inputVariables = {
      First_Name: formData.firstName,
      Last_Name: formData.lastName,
      Mobile_Number: formData.mobile,
      DOB: formData.dob,
      State: formData.state,
      District: formData.district,
      City: formData.city,
      Pincode: formData.pincode,

      ...(formData.email && { Email: formData.email }),
      ...(formData.occupation && { Occupation: formData.occupation }),
      ...(formData.address && { Address: formData.address }),
      ...(formData.maritalStatus && { Marital_Status: formData.maritalStatus }),
      ...(formData.identityProofType && { ID_Proof_Type: formData.identityProofType }),
      ...(formData.identityProofNumber && { ID_Proof_Number: formData.identityProofNumber }),
      ...(formData.panCard && { Pan_Card: formData.panCard }),
      ...(formData.panCardNumber && { Pan_Number: formData.panCardNumber }),
      ...(formData.star && { Star: formData.star }),
      ...(formData.raasi && { Raasi: formData.raasi }),
      ...(formData.kootram && { Kootram: formData.kootram }),
      ...(formData.kuladeivam && { Kuladeivam: formData.kuladeivam }),
      ...(formData.familyDetails && { Family_Details: formData.familyDetails }),
    };


    try {
      const { data } = await addMember({ variables: inputVariables });
      setOpenSnackbar(true);
      setSnackbarMessage("Member added successfully."); // ✅ Success message
      console.log("Member added:", data.addMember);
      window.location.href = '/manageusers';
    } catch (error) {
      console.error("Error adding member:", error);
      console.log("Member added:", inputVariables);
      const errorMessage = error?.message || "Something went wrong while adding member.";
      setSnackbarOpen(true);
      setSnackbarMessage(errorMessage);
    }
  };


  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  }




  // Handles radio button changes
  const handleRadioChange = (e) => {
    setFormData({ ...formData, identityProofType: e.target.value });
  };

  // Handles radio button changes
  const handlestatusChange = (e) => {
    setFormData({ ...formData, maritalStatus: e.target.value });
  };

  const handlePanChange = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, panCard: e.target.value, panCardNumber: e.target.value === "No" ? "" : formData.panCardNumber });


  };



  useEffect(() => {
    // Get mobile number & user type from localStorage
    const mobile = localStorage.getItem("mobile");
    const userType = localStorage.getItem("user_type");

    if (!mobile || !userType) {
      console.error("Mobile number or user type not found in localStorage");
      return;
    }

    window.scrollTo(0, 0);
  }, []);



  const districts = ["Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
    "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanyakumari", "Karur", "Karaikal",
    "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal",
    "Nilgiris", "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
    "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Thiruchirappalli", "Tirunelveli", "Tirupathur",
    "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore", "Viluppuram", "Virudhunagar", "Other"
  ];
  const states = ["Tamil Nadu", "Other"];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Box sx={{ backgroundColor: "#f8f9e9", py: 6, top: "150px", bottom: "150px" }}>
      <Container>
        <Typography variant="h5" sx={{ fontWeight: "500", color: "#2A289C", textAlign: "center", fontSize: "32px" }} gutterBottom>
          Member Registration
        </Typography>


        <form onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
              e.preventDefault(); // Prevent Enter key from submitting the form
            }
          }}
          >
          <Grid item xs={12} md={6}>
            <Box
              component="form"
              sx={{
                backgroundColor: "#f8f9e9",
                padding: 4,
                borderRadius: "8px",
                borderColors: "#CEC35E",
                boxShadow: 3,
                width: "95%",
                maxWidth: "890px",
                margin: "0 auto",
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField
                  fullWidth
                  size="small"
                  label="First Name"
                  placeholder="First Name"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  error={!!errors.firstName}
                  helperText={errors.firstName || ""}
                  sx={{ my: 2 }}
                  required
                />
                <TextField
                  fullWidth
                  size="small"
                  label="Last Name"
                  placeholder="Last Name"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  inputProps={{ maxLength: 25, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  error={!!errors.Last_Name}
                  helperText={errors.Last_Name || ""}
                  sx={{ my: 2 }}
                  required
                />


                <LocalizationProvider dateAdapter={AdapterDayjs} >
                  <DatePicker sx={{ my: 2 }}
                    label="Date of Birth"
                    // Display format
                    format="YYYY-MM-DD"
                    value={formData.dob ? dayjs(formData.dob, "YYYY-MM-DD") : null}
                    onChange={(date) => setFormData({ ...formData, dob: date ? date.format("YYYY-MM-DD") : "" })}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        error: !!errors.dob,
                        helperText: errors.dob || "",
                        required: true,

                      },
                      popper: {
                        sx: {
                          '& .MuiPaper-root': {
                            backgroundColor: '#f8f9e9',
                          },
                        },
                      },
                    }}
                    disableFuture
                    maxDate={dayjs().subtract(18, "year")}
                  />
                </LocalizationProvider>
                <TextField
                  fullWidth
                  size="small"
                  label="Mobile Number"
                  placeholder="Mobile Number"
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/\D/g, "");
                    if (inputValue.length <= 10) {
                      setFormData({ ...formData, mobile: inputValue });
                    }
                  }}

                  error={!!errors.Mobile_Number}
                  helperText={errors.Mobile_Number || " "}
                  sx={{ my: 2 }}
                  required
                />

                <Autocomplete
                  options={states}
                  sx={{ mt: 0 }}
                  value={formData.state}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setFormData({ ...formData, state: newValue });
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevents form submission
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="State"
                      variant="outlined"
                      size="small"
                      required
                      error={!!errors.state}
                      helperText={errors.state || ""}
                      sx={{
                        backgroundColor: "#f8f9e9",
                        mb: 2,
                        "& .MuiInputBase-input": {
                          caretColor: "transparent",
                          cursor: "pointer",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          backgroundColor: "#f8f9e9",
                          px: 1,
                          transform: "translate(14px, -6px) scale(0.75)",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: false,

                      }}
                    />
                  )}
                  disableClearable
                  fullWidth
                  autoHighlight

                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        backgroundColor: "#f8f9e9",
                      }}
                    />
                  )}
                />


                <Autocomplete
                  options={districts}
                  value={formData.district}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      setFormData({ ...formData, district: newValue });
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevents form submission
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="District"
                      variant="outlined"
                      size="small"
                      required
                      error={!!errors.district}
                      helperText={errors.district || ""}
                      sx={{
                        backgroundColor: "#f8f9e9",
                        mb: 2, mt: 0,
                        "& .MuiInputBase-input": {
                          caretColor: "transparent",
                          cursor: "pointer",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          backgroundColor: "#f8f9e9",
                          px: 1,
                          transform: "translate(14px, -6px) scale(0.75)",
                        },
                      }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: false,

                      }}
                    />
                  )}
                  disableClearable
                  fullWidth
                  autoHighlight

                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        backgroundColor: "#f8f9e9",
                      }}
                    />
                  )}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="City"
                  placeholder="City"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                  error={!!errors.City}
                  helperText={errors.City || ""}
                  sx={{ mb: 2, mt: 2 }}
                  required
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Pincode"
                  placeholder="Pincode"
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={(e) => {
                    const inputValue = e.target.value.replace(/\D/g, "");
                    if (inputValue.length <= 6) {
                      setFormData({ ...formData, pincode: inputValue });
                    }
                  }}
                  error={!!errors.pincode}
                  helperText={errors.pincode || ""}
                  sx={{ my: 2 }}
                  required
                />
                <TextField
                  fullWidth
                  size="small"
                  label="Address"
                  placeholder="Address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  sx={{ mb: 2, mt: 2 }}
                  inputProps={{ maxLength: 75, pattern: "[A-Za-z0-9,./\\-\\s]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9,./\-\s]/g, '')}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Email ID"
                  placeholder="Enter you Email ID"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  sx={{ mb: 2, mt: 2 }}
                  inputProps={{ maxLength: 50 }}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Occupation"
                  placeholder="Occupation"
                  type="text"
                  name="occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  sx={{ mb: 2, mt: 2 }}
                  inputProps={{ maxLength: 30, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                />



                <TextField
                  fullWidth
                  size="small"
                  label="Family Details"
                  placeholder="Number of Family Members"
                  name="familyDetails"
                  value={formData.familyDetails}
                  onChange={handleChange}
                  sx={{ mb: 2, mt: 2 }}
                  inputProps={{ maxLength: 70, pattern: "[A-Za-z0-9, ]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z0-9, ]/g, '')}
                />


                <Autocomplete
                  options={[
                    "Ashwini", "Bharani", "Krithikai", "Rohini", "Mirgasheersham", "Thiruvaathirai", "Punarpoosam", "Poosam",
                    , "Aayilyam", "Makam", "Pooram", "Uthiram", "Hastham", "Chithirai", "Swaathi", "Visaakam"
                    , "Anusham", "Kettai", "Moolam", "Pooraadam", "Uthiraadam", "Thiruvonam", "Avittam",
                    "Chathayam/Sadayam", "Poorattathi", "Uthirattathi", "Revathi"
                  ]}
                  value={formData.star || ""}
                  onChange={(event, newValue) => {
                    setFormData({ ...formData, star: newValue });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevents form submission
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Star"
                      variant="outlined"
                      size="small"

                      sx={{
                        backgroundColor: "#f8f9e9",
                        mb: 2, mt: 2,
                        "& .MuiInputBase-input": {
                          caretColor: "transparent",
                          cursor: "pointer",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          backgroundColor: "#f8f9e9",
                          px: 1,
                          transform: "translate(14px, -6px) scale(0.75)",
                        },
                      }}
                    />
                  )}
                  fullWidth
                  disableClearable
                  autoHighlight

                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        backgroundColor: "#f8f9e9",
                      }}
                    />
                  )}
                />

                <Autocomplete
                  options={[
                    "Mesham", "Risabham", "Mithunam", "Kadagam", "Simmam", "Kanni",
                    "Thulam", "Viruchigam", "Dhanushu", "Magaram", "Kumbham", "Meenam"
                  ]}
                  value={formData.raasi || ""}
                  onChange={(event, newValue) => {
                    setFormData({ ...formData, raasi: newValue });
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevents form submission
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Raasi"
                      variant="outlined"
                      size="small"
                      sx={{
                        backgroundColor: "#f8f9e9",
                        mb: 2, mt: 2,
                        "& .MuiInputBase-input": {
                          caretColor: "transparent",
                          cursor: "pointer",
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          backgroundColor: "#f8f9e9",
                          px: 1,
                          transform: "translate(14px, -6px) scale(0.75)",
                        },
                      }}
                    />
                  )}
                  fullWidth
                  disableClearable
                  autoHighlight

                  PaperComponent={(props) => (
                    <Paper
                      {...props}
                      sx={{
                        backgroundColor: "#f8f9e9",
                      }}
                    />
                  )}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Gothram"
                  placeholder="Gothram"
                  name="kootram"
                  value={formData.kootram}
                  onChange={handleChange}
                  sx={{ my: 2 }}
                  inputProps={{ maxLength: 50, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                />

                <TextField
                  fullWidth
                  size="small"
                  label="Kuladeivam"
                  placeholder="Kuladeivam"
                  name="kuladeivam"
                  value={formData.kuladeivam}
                  onChange={handleChange}
                  sx={{ my: 2 }}
                  inputProps={{ maxLength: 50, pattern: "[A-Za-z]*" }}
                  onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={2}>
                    <FormLabel sx={{ whiteSpace: "nowrap" }}></FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={20}>
  <Autocomplete
    options={["Single", "Married"]}
    value={formData.maritalStatus || ""}
    onChange={(event, newValue) => {
      setFormData({ ...formData, maritalStatus: newValue });
    }}
    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault(); // Prevents form submission
                        }
                      }}
    fullWidth
    autoHighlight
    disableClearable
    renderInput={(params) => (
      <TextField
        {...params}
        label="Marital Status"
        variant="outlined"
        size="small"
        required
        error={!!errors.maritalStatus}
        helperText={errors.maritalStatus || ""}
        sx={{
          backgroundColor: "#f8f9e9",
          mb: 2,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#ccc", // default
            },
            "&:hover fieldset": {
              borderColor: "#999", // hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "#f1c40f !important", // yellow on focus
              borderWidth: "2px",
            },
          },
        }}
      />
    )}
    PaperComponent={(props) => (
      <Paper
        {...props}
        sx={{
          backgroundColor: "#f8f9e9",
        }}
      />
    )}
  />
</Grid>

                </Grid>

                <Box>
                  <Grid container spacing={2} alignItems="center">
                    {/* ID Proof Label & Radio Buttons in One Row */}
                    <Grid item xs={2}>
                      <FormLabel sx={{ whiteSpace: "nowrap" }} >ID Proof </FormLabel>

                    </Grid>
                    <Grid item xs={12} sm={10} >
                      <FormControl component="fieldset" style={{ marginLeft: "22px" }}  >
                        <RadioGroup
                          row
                          name="identityProofType"
                          value={formData.identityProofType}
                          onChange={handleRadioChange}
                        >
                          <FormControlLabel
                            value="aadhaar"
                            control={<Radio sx={{ color: "gray" }} />}
                            label="Aadhaar"
                          />
                          <FormControlLabel
                            value="license"
                            control={<Radio sx={{ color: "grey" }} />}
                            label="License"
                          />

                        </RadioGroup>
                      </FormControl>
                    </Grid>

                    {/* Aadhar Number Field */}
                    {formData.identityProofType === "aadhaar" && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Aadhaar Number"
                          type="text"
                          name="identityProofNumber"
                          value={formData.identityProofNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "").slice(0, 12); // Keep only numbers
                            setFormData((prev) => ({ ...prev, identityProofNumber: value }));
                          }}
                          error={isSubmitted && (!formData.identityProofNumber || formData.identityProofNumber.length !== 12)}
                          helperText={
                            isSubmitted && (
                              !formData.identityProofNumber
                                ? " "
                                : formData.identityProofNumber.length !== 12
                                  ? " "
                                  : ""
                            )
                          }
                          placeholder="Enter Aadhaar Number"

                          inputProps={{ maxLength: 12 }}
                        />
                      </Grid>
                    )}

                    {/* License Number Field */}
                    {formData.identityProofType === "license" && (
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="License Number"
                          type="text"
                          name="identityProofNumber"
                          value={formData.identityProofNumber}
                          onChange={handleChange}
                          error={
                            isSubmitted &&
                            (!formData.identityProofNumber
                              ? true
                              : !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber))
                          }
                          helperText={
                            isSubmitted &&
                            (!formData.identityProofNumber
                              ? " "
                              : !/^[A-Z]{2}\d{13}$/.test(formData.identityProofNumber)
                                ? " "
                                : "")
                          }
                          inputProps={{ maxLength: 15 }}
                          placeholder="Enter License Number"
                          onInput={(e) =>
                            (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15))
                          }
                        />
                      </Grid>
                    )}
                  </Grid>
                </Box>


                {/* PAN Requirement Selection */}
                <Box sx={{ backgroundColor: "#f8f9e9" }}>
                  <Grid container spacing={2} alignItems="center">

                    {/* PAN Number Label */}
                    <Grid item xs={2}>
                      <FormLabel sx={{ whiteSpace: "nowrap" }} >PAN Card</FormLabel>
                    </Grid>

                    {/* PAN Required Radio Buttons */}
                    <Grid item xs={12} sm={10} >
                      <FormControl component="fieldset" style={{ marginRight: "56px" }} >
                        <RadioGroup row name="panCard" value={formData.panCard} onChange={handlePanChange}>
                          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                          <FormControlLabel value="No" control={<Radio />} label="No" />

                        </RadioGroup>
                      </FormControl>
                    </Grid>

                  </Grid>


                  {/* PAN Number Field (Only if "Yes" is selected) */}
                  {formData.panCard === "Yes" && (


                    <Grid item xs={12} sx={{ mt: 2 }} >
                      <TextField
                        fullWidth
                        size="small"
                        label="PAN Number"
                        placeholder="Enter PAN Number"
                        name="panCardNumber"
                        value={formData.panCardNumber}
                        onChange={handleChange}
                        error={
                          isSubmitted &&
                          (!formData.panCardNumber
                            ? true
                            : !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.panCardNumber))
                        }
                        helperText={
                          isSubmitted &&
                          (!formData.panCardNumber
                            ? " "
                            : !/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.panCardNumber)
                              ? " "
                              : "")
                        }
                        inputProps={{ maxLength: 10 }}
                        onInput={(e) =>
                          (e.target.value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10))
                        }
                      />
                    </Grid>

                  )}

                </Box>
              </div>
            </Box>
            <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
              <Grid item>

                {isLoading ? (
                  <CircularProgress color="success" />
                ) : (
                  <Button type="submit" variant="contained" onClick={handleSubmit} fullWidth style={{ backgroundColor: "green", color: "white" }}>
                    Create Member
                  </Button>
                )}
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  fullWidth
                  style={{ backgroundColor: "#E52029", color: "white" }}
                  onClick={() => {
                    navigate("/manageusers");
                    window.scrollTo(0, 0);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>

              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
      {/* Snackbar Alert */}
      <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: "top", horizontal: "right" }} >
        <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>
          Member Created Successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={snackbarOpen} autoHideDuration={10000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%", fontSize: "16px", fontWeight: "bold" }}>{snackbarMessage}</Alert></Snackbar>
    </Box>
  );
}